import { Home, LandPlot, Hammer, Scale, Sparkles, ShieldCheck, Umbrella, Landmark, TrendingUp } from "lucide-react";

export const SERVICES = [
  {
    id: "villa-management",
    icon: Home,
    title: "Rent-O-Villa",
    tagline: "Own, rent & manage",
    short:
      "One stop solution to own, rent and manage all your property needs. List your villa with LAVista and earn through profit-sharing while we take complete ownership of upkeep and maintenance.",
    points: [
      "Own, rent & manage in one place",
      "Revenue profit-sharing with owners",
      "Complete upkeep & maintenance ownership",
      "Guest handling & transparent reporting",
    ],
    image:
      "https://images.unsplash.com/photo-1609319172668-8b4f021f3b7b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHx3b29kZW4lMjB2aWxsYSUyMG5hdHVyZXxlbnwwfHx8fDE3ODM5MTk5NDJ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "buy-sell",
    icon: LandPlot,
    title: "Buy & Sell",
    tagline: "Land, villas & more",
    short:
      "Buy or sell land, villas and premium properties with expert advisory and verified listings across scenic locations.",
    points: [
      "Curated villa & land inventory",
      "Verified titles & fair pricing",
      "End-to-end deal advisory",
      "Investment yield guidance",
    ],
    image:
      "https://images.unsplash.com/photo-1650429356490-f461d720fcc9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHx3b29kZW4lMjB2aWxsYSUyMG5hdHVyZXxlbnwwfHx8fDE3ODM5MTk5NDJ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "design-construction",
    icon: Hammer,
    title: "Design & Construction",
    tagline: "Imported pine wooden villas",
    short:
      "Our specialty: bespoke villas crafted from imported pine wood. From architecture to handover, we build dream homes that last.",
    points: [
      "Specialised in imported pine wood",
      "Custom architecture & interiors",
      "Sustainable, durable builds",
      "Turnkey project delivery",
    ],
    image:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "legal",
    icon: Scale,
    title: "Legal Services",
    tagline: "Property law, simplified",
    short:
      "Comprehensive legal support for every property transaction — title verification, documentation, and compliance.",
    points: [
      "Title & due-diligence checks",
      "Sale-deed & agreement drafting",
      "Registration assistance",
      "Dispute & compliance advisory",
    ],
    image:
      "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "value-added",
    icon: Sparkles,
    title: "Value-Added Services",
    tagline: "Beyond the four walls",
    short:
      "Elevate your property with EV chargers, adventure & game zones, and lush horticulture landscaping.",
    points: [
      "EV charger installation",
      "Game & adventure zones",
      "Horticulture & landscaping",
      "Custom lifestyle add-ons",
    ],
    image:
      "https://images.unsplash.com/photo-1700689807667-82630348b301?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxob3J0aWN1bHR1cmUlMjBnYXJkZW4lMjBsYW5kc2NhcGV8ZW58MHx8fHwxNzgzOTE5OTQxfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "safety-audits",
    icon: ShieldCheck,
    title: "Safety Audits",
    tagline: "Peace of mind, verified",
    short:
      "Comprehensive structural, fire and electrical safety audits so your villa meets every standard and stays protected.",
    points: [
      "Structural & fire safety checks",
      "Electrical & gas line audits",
      "Compliance certification support",
      "Actionable risk reports",
    ],
    image:
      "https://images.unsplash.com/photo-1581094794329-c8112a89af12?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "insurance",
    icon: Umbrella,
    title: "Insurance",
    tagline: "Protect what matters",
    short:
      "Tailored property insurance covering your villa, contents and liability — arranged and managed end-to-end.",
    points: [
      "Property & contents cover",
      "Natural calamity protection",
      "Liability & tenant cover",
      "Hassle-free claims assistance",
    ],
    image:
      "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "mortgage-loans",
    icon: Landmark,
    title: "Mortgage & Loans",
    tagline: "Finance made simple",
    short:
      "Get the best home loan and mortgage options with our lending partners — competitive rates and quick approvals.",
    points: [
      "Home loan sourcing & comparison",
      "Mortgage & refinancing options",
      "Documentation assistance",
      "Fast-tracked approvals",
    ],
    image:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "investment-advisor",
    icon: TrendingUp,
    title: "Investment Advisor",
    tagline: "Grow your real estate wealth",
    short:
      "Expert advisory to build and optimise your property portfolio — from rental yields to appreciation strategy.",
    points: [
      "Portfolio & yield analysis",
      "Location & appreciation insights",
      "Rental income optimisation",
      "Exit & resale strategy",
    ],
    image:
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title);
